import { useState } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

const fmtDateTime = (iso?: string): string =>
  iso ? moment(iso).format("DD.MM.YYYY HH:mm") : "—";

const PIDeliveranceMetricSlide: FC<Props> = ({ deliverance, onClose }) => {
  const d = deliverance;

  // Domyślnie sekcja „Doręczenie" zwinięta, pozostałe rozwinięte.
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({
    delivery: true,
  });
  const toggle = (key: string) =>
    setCollapsed((p) => ({ ...p, [key]: !p[key] }));

  const SectionHeader = ({ id, label }: { id: string; label: string }) => (
    <div className={styles.sectionTitle} onClick={() => toggle(id)}>
      <span>{label}</span>
      <FontAwesomeIcon
        className={styles.sectionChevron}
        icon={collapsed[id] ? faChevronRight : faChevronDown}
      />
    </div>
  );

  return (
    <div
      className={styles.overlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.panel}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <span className={styles.headerTitle}>Metryka Doręczenia PI</span>
            {d.CaseSignature && (
              <span className={styles.headerSub}>{d.CaseSignature}</span>
            )}
          </div>
          <button className={styles.closeBtn} onClick={onClose} title="Zamknij">
            ✕
          </button>
        </div>

        <div className={styles.body}>
          {/* ── Dane sprawy ── */}
          <SectionHeader id="case" label="Dane sprawy" />
          {!collapsed.case && (
            <div className={styles.metaCard}>
              <div className={styles.metaGrid}>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Sygnatura akt</span>
                  <span className={styles.metaValue}>
                    {d.CaseSignature || "—"}
                  </span>
                </div>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Sędzia / referent</span>
                  <span className={styles.metaValue}>{d.Judge || "—"}</span>
                </div>
                <div className={styles.metaItem} style={{ gridColumn: "span 2" }}>
                  <span className={styles.metaLabel}>Sąd</span>
                  <span className={styles.metaValue}>{d.Court || "—"}</span>
                </div>
                <div className={styles.metaItem} style={{ gridColumn: "span 2" }}>
                  <span className={styles.metaLabel}>Wydział</span>
                  <span className={styles.metaValue}>{d.Department || "—"}</span>
                </div>
                <div className={styles.metaItem} style={{ gridColumn: "span 2" }}>
                  <span className={styles.metaLabel}>Klient</span>
                  <span className={styles.metaValue}>{d.Client || "—"}</span>
                </div>
              </div>
            </div>
          )}

          {/* ── Pismo ── */}
          <SectionHeader id="document" label="Pismo" />
          {!collapsed.document && (
            <div className={styles.metaCard}>
              <div className={styles.metaTitleRow}>
                <div className={styles.metaTitleLabel}>Tytuł pisma</div>
                <div className={styles.metaTitleValue}>{d.Title || "—"}</div>
              </div>
              <div className={styles.metaGrid}>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Rodzaj dokumentu</span>
                  <span className={styles.metaValue}>
                    {d.DocumentType || "—"}
                  </span>
                </div>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Status</span>
                  <span className={styles.metaValue}>{d.Status || "—"}</span>
                </div>
              </div>
            </div>
          )}

          {/* ── Doręczenie ── */}
          <SectionHeader id="delivery" label="Doręczenie" />
          {!collapsed.delivery && (
            <div className={styles.metaCard}>
              <div className={styles.metaGrid}>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Publikacja w PI</span>
                  <span className={styles.metaValue}>
                    {fmtDateTime(d.PublicationDate)}
                  </span>
                </div>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Doręczenie</span>
                  <span className={styles.metaValue}>
                    {fmtDateTime(d.DeliveryDate)}
                  </span>
                </div>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Odczytano</span>
                  <span className={styles.metaValue}>
                    {fmtDateTime(d.ReadDate)}
                  </span>
                </div>
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>Nr w portalu</span>
                  <span className={styles.metaValue}>
                    {d.PortalDocumentId || "—"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PIDeliveranceMetricSlide;
